import { render } from "./index.vue?vue&type=template&id=a05345ea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a05345ea&scoped=true&lang=css"

import exportComponent from "D:\\learning\\isp_digital\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a05345ea"]])

export default __exports__